import React, {useContext, useEffect} from 'react';
import {injectIntl} from "react-intl";
import SelectField from "@FormElements/SelectField";
import FormContext from "formContext";

function NoticePeriodField({intl, settings, ...rest}) {
  const { additionalData: {masterLists}, currentStep, formName, setFormData, getFormSchema, setFormSchema, setErrors } = useContext(FormContext);

  settings.options = [{
    value: '',
    label: intl.formatMessage({id: 'Register.Form.NoticePeriod.Field.EmptyOption'})
  }];

  if (masterLists && masterLists.hasOwnProperty('NoticePeriods')) {
    const {NoticePeriods} = masterLists;
    if (NoticePeriods.length) {
      NoticePeriods.forEach(period => {
        settings.options.push({
          value: period.Code,
          label: period.ListValue
        });
      });
    }
  }
  const setPeriod = (value) => {
    let schema = getFormSchema(formName);

    const availableFromIndex = schema[currentStep].data[0].components.findIndex(item => {
      if (item.settings && item.settings.name && item.settings.name === 'available_from') {
        return item
      }
    })

    if (value === '80') {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        prev[currentStep]['available_from'] = '';
        prev[currentStep]['can_select_available_from'] = true;

        return {
          ...prev
        }
      });

      schema[currentStep].data[0].components[availableFromIndex].settings.hidden = false;
      setFormSchema(formName, schema);
    }
    else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        prev[currentStep]['available_from'] = '';
        prev[currentStep]['can_select_available_from'] = false;

        return {
          ...prev
        }
      });

      schema[currentStep].data[0].components[availableFromIndex].settings.hidden = true;
      setFormSchema(formName, schema);
    }
  }

  rest.onChange = e => {
    const {value} = e.target;
    setErrors();
    setPeriod(value);
  }

  const period = (settings.state) && (settings.state.notice_period) ? settings.state.notice_period : ''
  useEffect(() => {
    setPeriod(period);
  }, [])

  return (
    <SelectField
      settings={settings}
      {...rest}
    />
  )

}

export default injectIntl(NoticePeriodField);
